import {Injectable} from '@angular/core';
import {RegisterDataTableService} from '../../../core/services/register-data-table.service';
import {StorageService} from '../../../core/services/storage.service';
import {ITableColumn} from '../../../core/common/interfaces/table-column.interface';


@Injectable({
  providedIn: 'root'
})
export class GroupTableService extends RegisterDataTableService {


  constructor(
    storageService: StorageService
  ) {
    super(storageService);
  }


  override getColumns(): ITableColumn[] {
    return [
      {
        name: 'id',
        title: 'Id',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'name',
        title: 'Полное наименование',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'shortName',
        title: 'Краткое наименование',
        default: true,
        useCustomTemplate: false,

      },
      {
        name: 'object',
        title: 'Объекты',
        useCustomTemplate: true,
        default: true,
        maxWidth: '90px'
      },
      {
        name: 'status',
        title: 'Архив',
        useCustomTemplate: true,
        default: true,
      },
    ];
  }


}
